import React from 'react';

import FeatureBlock from '../FeatureBlock/FeatureBlock';
import * as styles from './ServicesList.module.scss';

const ServicesList = ({ nodes, ...other }) => {
  return !nodes ? null : (
    <ul {...other} className={styles.container}>
      {nodes.map(({ id, title, uri, cover: { lead, image } }) => {
        return (
          <li key={id}>
            <FeatureBlock
              title={title}
              description={lead}
              image={image}
              path={uri}
              isSecondary
            />
          </li>
        );
      })}
    </ul>
  );
};

export default ServicesList;
